<template>
  <section class="reportFormList">
    <viewTitle
      class="viewTitle"
      title="业务管理 / 报表中心"
      :showReturn="false"
    />
    <div class="listAdmin">
      <p class="">
        <span class="listAdminT">报表接收人员：</span>
        <template v-for="(itemList, index) in listSuperAdmin">
          <span
            class="adminItem"
            v-for="(item, indexItem) in itemList"
            :key="indexItem"
          >
            <User :item="item" :type="index" />
          </span>
        </template>
        <el-button type="text" @click="selectSuperAdmin" size="small"
          >修改</el-button
        >
      </p>
    </div>
    <Dept
      :model="deptListObj.model"
      :title="deptListObj.title"
      :visible="deptListObj.visible"
      :selected="deptListObj.pluginResult.select"
      @confirm="deptListObjConfirm"
      @updateVisible="deptListObjUpdateVisible"
    />
  </section>
</template>

<script>
import viewTitle from "@/components/viewTitle";
import Dept from "@/components/qyDept/";
import User from "@/components/qyDept/user";

export default {
  data() {
    return {
      deptListObj: {
        title: "报表接收人员",
        model: "both",
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false
        // urlType: "sysAdmin"
      },
      listSuperAdmin: { org: [], group: [], user: [] }
    };
  },

  components: {
    // pagi,
    viewTitle,
    Dept,
    User
  },

  computed: {},

  mounted() {},

  async activated() {},

  created() {
    this.$common
      .http({
        url: "/api/queue/summary/detail_config"
      })
      .then(res => {
        this.listSuperAdmin = {
          org: res.data.data.depts,
          group: res.data.data.groups,
          user: res.data.data.users
        };
        this.deptListObj.pluginResult.select = {
          org: res.data.data.depts,
          group: res.data.data.groups,
          user: res.data.data.users
        };
      });
  },

  methods: {
    deptListObjConfirm(obj) {
      for (let key in obj) {
        this.deptListObj.pluginResult.select[key] = obj[key];
      }
      this.setSuperAdminUser();
    },
    deptListObjUpdateVisible(val) {
      this.deptListObj.visible = val;
    },
    selectSuperAdmin() {
      this.deptListObj.visible = true;
    },
    setSuperAdminUser() {
      let dept_ids = [];
      this.deptListObj.pluginResult.select.org.forEach(item => {
        dept_ids.push(item.id);
      });
      let user_ids = [];
      this.deptListObj.pluginResult.select.user.forEach(item => {
        user_ids.push(item.id);
      });
      let group_ids = [];
      this.deptListObj.pluginResult.select.group.forEach(item => {
        group_ids.push(item.id);
      });
      this.$common
        .http({
          url: "/api/queue/summary/save_config",
          data: {
            dept_ids,
            user_ids,
            group_ids
          }
        })
        .then(() => {
          this.$common.pcToastSuccess("修改成功");
          this.listSuperAdmin = this.deptListObj.pluginResult.select;
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.reportFormList {
  .viewTitle {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 16px 0 16px;
    height: 59px;
    border-bottom: 1px solid #e4e4e4;
  }
  .listAdmin {
    padding: 16px;
    > p {
      margin: 0;
    }
  }
  .adminItem {
    margin-right: 10px;
  }
}
</style>
<style lang="less">
.adminItem {
  margin-right: 5px;
  .el-icon-close {
    display: none;
  }
}
</style>
